// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__21OiZ","title":"Header_title__2Hgo0","left":"Header_left__24cGB","clinicName":"Header_clinicName__1KDKY"};